export default {
    title: '打字对战',
    common: {
        time: '{minutes}分 {seconds}秒',
        kpmUnit: '{count}字/分',
        noKill: '尚未击败',
        notEnoughStar: {
            title: '表扬星不足',
            message: '开始打字对战需要 1 颗表扬星。',
            confirm: '确认',
        },
    },
    index: {
        back: '返回',
        classroomTitle: '{school} {grade}年级 {class_name}',
        header: {
            name: '姓名',
            phase: '阶段',
            accuracy: '准确',
            time: '时间',
            kpm: '速度',
            date: '日期',
        },
        meMark: '我',
        recentRecord: '最近',
        myRanking: '我的排名',
        empty: '暂无记录。',
        startRaid: '开始挑战',
        startFailed: '无法开始挑战。',
    },
    inplay: {
        phase: '阶段 {phase}',
        exit: '退出',
        combo: '连击',
        transition: {
            phase: '阶段',
            completed: '完成！',
            awakening: '阶段 {phase} BOSS 觉醒中...',
            loading: '加载中...',
            skip: '跳过',
        },
        nextLabel: '下一句：{next}',
        inputLabel: '提交',
        leaveModal: {
            title: '现在退出吗？',
            message: '如果现在退出，本次打字对战将以当前记录结束。<br />确定要退出吗？',
            no: '否',
            yes: '是',
        },
        contentError: {
            title: '内容加载失败',
            message: '请稍后再试。',
            confirm: '确认',
        },
    },
    result: {
        gameOver: '游戏结束',
        bestRecord: '刷新了最佳记录！请返回大厅查看排行。',
        reachedPhase: '达到阶段',
        defeatedBoss: '击败 BOSS',
        defeatedUnit: '只',
        lastBoss: '最后 BOSS',
        targetKpmTooltip: '{grade}年级目标速度：{targetKpm}字/分',
        ranking: '返回大厅',
        retry: '重新开始',
        registered: {
            title: '已加入班级排行！',
            message: '阶段越高排名越靠前，阶段相同时，准确率与速度越高排名越靠前。',
        },
        stats: {
            maxCombo: '最大连击',
            accuracy: '准确率',
            typo: '错字',
            time: '用时',
            kpm: '速度',
            comboUnit: '{count}连击',
            accuracyUnit: '{count}%',
            typoUnit: '{count}次',
            kpmUnit: '{count}字/分',
        },
    },
};
